import instance from "../apis/axiosConfig";

// GET ALL
export const getFeedbackSettings = () =>
  instance.get("feedbackSettings/getAll");

// UPDATE
export const updateFeedbackSettings = (id,data) =>
  instance.post(`feedbackSettings/update/${id}`, data);